import setPrototypeOf from "./setPrototypeOf";
export default function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/pickers/~/@babel/runtime/helpers/esm/inherits.js
// module id = 268
// module chunks = 121